<template>
	<div>
		<el-upload ref="upload" :action="action" list-type="picture-card" :auto-upload="true"
			:file-list="internalFileList" :disabled="disabled" :headers="headers" :data="data" :on-remove="handleRemove"
			:on-success="handleSuccess" :on-error="handleError" :on-change="handleChange"
			:on-preview="handlePictureCardPreview" :on-exceed="handleExceed"
			:class="{ 'max-size': internalFileList.length >= limit }">
			<!-- 上传按钮：只有未超过 limit 时才显示 -->
			<i slot="default" class="el-icon-plus"></i>

			<template slot="file" slot-scope="{ file }">
				<img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
				<span class="el-upload-list__item-actions">
					<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
						<i class="el-icon-zoom-in"></i>
					</span>
					<span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
						<i class="el-icon-delete"></i>
					</span>
				</span>
			</template>
		</el-upload>

		<el-dialog :visible.sync="dialogVisible">
			<img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
	</div>
</template>

<script>
import apis from '@/http/api'
import store from '@/store'
import { baseURL } from '@/config.js'

const uploadUrl = baseURL + apis.upload

export default {
	name: "UploadPictureCard",
	props: {
		action: { type: String, default: uploadUrl },
		disabled: { type: Boolean, default: false },
		limit: { type: Number, default: 5 },
		fileList: { type: Array, default: () => [] },
		headers: {
			type: Object, default: () => ({
				token: store.state.token
			})
		},
		data: { type: Object, default: () => ({}) }
	},
	data() {
		return {
			internalFileList: [...this.fileList],
			dialogImageUrl: '',
			dialogVisible: false
		};
	},
	watch: {
		fileList: {
			handler(val) {
				this.internalFileList = [...val];
			},
			deep: true
		}
	},
	methods: {
		handleRemove(file) {
			this.internalFileList = this.internalFileList.filter(f => f.uid !== file.uid);
			this.$emit("update:fileList", this.internalFileList);
			this.$emit("remove", file);
		},
		handleChange(file, fileList) {
			this.internalFileList = [...fileList];
			this.$emit("update:fileList", this.internalFileList);
			this.$emit("change", file, fileList);
		},
		handleSuccess(response, file, fileList) {
			file.url = response.data.fullurl || file.url;
			file.pathUrl = response.data.url || file.url;
			// console.log(response, file, fileList)
			this.handleChange(file, fileList);
			this.$emit("success", response, file, fileList);
		},
		handleError(err, file, fileList) {
			this.$emit("error", err, file, fileList);
		},
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.dialogVisible = true;
			this.$emit("preview", file);
		},
		handleExceed() {
			// 不提示了，按钮隐藏即可
		}
	}
};
</script>

<style lang="scss" scoped>
.el-upload-list__item-actions span {
	margin-left: 5px;
}

.max-size {
	::v-deep .el-upload {
		display: none;
	}
}

::v-deep .el-upload--picture-card {
	background-color: #00000000;
}
</style>
